export const translations = {
    en: {
        nav: {
            manifesto: "Manifesto",
            services: "Services",
            process: "Process",
            contact: "Contact",
            cta: "Start a Conversation",
        },
        hero: {
            overline: "Clarke Business Solutions — Est. 2026",
            line1: "Your business,",
            line2: "sharply",
            line3: "organised.",
            sub: "Clarke Business Solutions advises entrepreneurs on business operations, process optimisation and business development — and builds the custom software that puts that advice into practice.",
            cta1: "Start a Conversation",
            cta2: "Explore the Approach",
            scroll: "Scroll",
        },
        marquee: [
            "Business Consultancy",
            "Process Optimisation",
            "Management Support",
            "Custom Software",
            "The Clarke Platform",
            "Business Matchmaking",
        ],
        manifesto: {
            tag: "The Manifesto",
            headingA: "Built on a simple",
            headingB: "conviction",
            imageCaption: "Precision, engineered.",
            chapters: [
                {
                    n: "01",
                    title: "What we do",
                    body: "We advise entrepreneurs on how their business runs: processes, planning, costs and growth. Where advice alone is not enough, we build the software that makes it real — like our own Clarke platform for planning, CRM, invoicing and production data.",
                },
                {
                    n: "02",
                    title: "Why we exist",
                    body: "Because good entrepreneurs get lost in daily noise. Talented people were never meant to copy data between spreadsheets or guess at their margins. Every hour lost to manual work is an hour stolen from growth — we give those hours back.",
                },
                {
                    n: "03",
                    title: "How we work",
                    body: "Quietly and precisely. First we listen, then we map, then we advise — and only then we build. No bloated consultancy reports, no disruptive rollouts — just changes that slot into your operation and pay for themselves.",
                },
            ],
        },
        services: {
            tag: "Capabilities",
            headingA: "What we do",
            headingB: "for you",
            intro: "Advice as the foundation, technology as the tool: a business that runs on insight instead of stress.",
            imageCaption: "At the table with the entrepreneur.",
            tiles: [
                {
                    id: "consultancy",
                    title: "Business Consultancy",
                    body: "A sharp look at your management and operations: processes, costs, planning and growth. Practical advice you can execute the same week.",
                },
                {
                    id: "optimisation",
                    title: "Process Optimisation",
                    body: "We map how work actually flows through your company, find where hours and margin leak away, and design a smarter way of working.",
                },
                {
                    id: "platform",
                    title: "The Clarke Platform",
                    body: "Our own business software for planning, CRM, invoicing and production data — used daily for our own books, and available to clients when it genuinely fits.",
                },
                {
                    id: "custom",
                    title: "Custom Software",
                    body: "When standard tools fall short, we build programs around the way your company works — not the other way around.",
                },
                {
                    id: "integration",
                    title: "Systems Integration",
                    body: "Your software finally talks to each other. One source of truth across finance, stock, sales and operations.",
                },
                {
                    id: "matchmaking",
                    title: "Business Matchmaking",
                    body: "We connect you with the right business partners and service providers — independent, and always in your interest.",
                },
            ],
        },
        process: {
            tag: "The Process",
            headingA: "Four movements,",
            headingB: "one direction",
            imageCaption: "Every hour, exactly where it should be.",
            steps: [
                {
                    n: "01",
                    title: "Explore",
                    body: "We sit with your team and go through your processes and numbers — no assumptions, no jargon.",
                },
                {
                    n: "02",
                    title: "Advise",
                    body: "A clear-eyed advice: what to improve, in what order, and exactly how much time and money it returns.",
                },
                {
                    n: "03",
                    title: "Implement",
                    body: "We guide the change in focused steps — with our own software where it helps — while your operation keeps moving.",
                },
                {
                    n: "04",
                    title: "Anchor",
                    body: "Afterwards we measure, tune and extend — improvements that stick and grow with your business.",
                },
            ],
        },
        contact: {
            tag: "The Invitation",
            headingA: "Let's talk about",
            headingB: "your business",
            sub: "Tell us where the pressure sits. We'll show you what it looks like when it's gone.",
            note: "Prefer direct contact? Email us — or use the form and we reply within one business day.",
            nameLabel: "Name",
            namePlaceholder: "Your name",
            emailLabel: "Email",
            emailPlaceholder: "you@company.com",
            companyLabel: "Company (optional)",
            companyPlaceholder: "Your company",
            messageLabel: "Message",
            messagePlaceholder: "Tell us about your processes…",
            submit: "Send Message",
            sending: "Sending…",
            success: "Message received — we reply within one business day.",
            error: "Something went wrong. Please try again.",
        },
        footer: {
            tagline: "Advice on business operations, process optimisation and business development for entrepreneurs — strengthened by custom software that automates and optimises business processes.",
            contactLabel: "Contact",
            contactVia: "Via the contact form",
            location: "The Netherlands",
            exploreLabel: "Explore",
            copyright: "© 2026 Clarke Business Solutions",
            kvk: "KvK 42207779",
            motto: "Business operations, perfected",
        },
    },
    nl: {
        nav: {
            manifesto: "Manifest",
            services: "Diensten",
            process: "Werkwijze",
            contact: "Contact",
            cta: "Start een gesprek",
        },
        hero: {
            overline: "Clarke Business Solutions — Est. 2026",
            line1: "Uw bedrijf,",
            line2: "scherp",
            line3: "georganiseerd.",
            sub: "Clarke Business Solutions adviseert ondernemingen over bedrijfsvoering, procesoptimalisatie en bedrijfsontwikkeling — en bouwt waar nodig de maatwerksoftware die dat advies in de praktijk brengt.",
            cta1: "Start een gesprek",
            cta2: "Ontdek onze aanpak",
            scroll: "Scroll",
        },
        marquee: [
            "Bedrijfsadvies",
            "Procesoptimalisatie",
            "Managementondersteuning",
            "Maatwerk Software",
            "Het Clarke Platform",
            "Zakelijke Bemiddeling",
        ],
        manifesto: {
            tag: "Het Manifest",
            headingA: "Gebouwd op een simpele",
            headingB: "overtuiging",
            imageCaption: "Precisie, geconstrueerd.",
            chapters: [
                {
                    n: "01",
                    title: "Wat wij doen",
                    body: "Wij adviseren ondernemers over hun bedrijfsvoering: processen, planning, kosten en groei. Waar advies alleen niet genoeg is, bouwen wij zelf de software die het waarmaakt — zoals het Clarke-platform voor planning, CRM, facturatie en productiedata.",
                },
                {
                    n: "02",
                    title: "Waarom wij bestaan",
                    body: "Omdat goede ondernemers verdwalen in de drukte van alledag. Getalenteerde mensen zijn nooit bedoeld om data tussen spreadsheets te kopiëren of hun marges te gokken. Elk uur handmatig werk is een uur dat niet naar groei gaat — wij geven die uren terug.",
                },
                {
                    n: "03",
                    title: "Hoe wij werken",
                    body: "Rustig en precies. Eerst luisteren, dan in kaart brengen, dan adviseren — en pas dan bouwen. Geen dikke adviesrapporten, geen verstoring van uw operatie — gewoon veranderingen die naadloos in uw bedrijf passen en zichzelf terugverdienen.",
                },
            ],
        },
        services: {
            tag: "Diensten",
            headingA: "Wat wij voor",
            headingB: "u doen",
            intro: "Advies als fundament, technologie als gereedschap: een bedrijf dat draait op inzicht in plaats van stress.",
            imageCaption: "Aan tafel bij de ondernemer.",
            tiles: [
                {
                    id: "consultancy",
                    title: "Bedrijfsadvies",
                    body: "Een scherpe blik op uw management en bedrijfsvoering: processen, kosten, planning en groei. Praktisch advies dat u dezelfde week nog uitvoert.",
                },
                {
                    id: "optimisation",
                    title: "Procesoptimalisatie",
                    body: "Wij brengen in kaart hoe het werk écht door uw bedrijf stroomt, vinden waar uren en marge weglekken en ontwerpen een slimmere manier van werken.",
                },
                {
                    id: "platform",
                    title: "Het Clarke Platform",
                    body: "Onze eigen bedrijfssoftware voor planning, CRM, facturatie en productiedata — dagelijks in gebruik voor onze eigen administratie, en beschikbaar voor klanten als het écht past.",
                },
                {
                    id: "custom",
                    title: "Maatwerk Software",
                    body: "Wanneer standaardpakketten tekortschieten, bouwen wij programma's rond de manier waarop úw bedrijf werkt — niet andersom.",
                },
                {
                    id: "integration",
                    title: "Systeemintegratie",
                    body: "Uw software praat eindelijk met elkaar. Eén bron van waarheid voor financiën, voorraad, verkoop en operatie.",
                },
                {
                    id: "matchmaking",
                    title: "Zakelijke Bemiddeling",
                    body: "Wij verbinden u met de juiste zakelijke partners en dienstverleners — onafhankelijk en altijd in úw belang.",
                },
            ],
        },
        process: {
            tag: "De Werkwijze",
            headingA: "Vier stappen,",
            headingB: "één richting",
            imageCaption: "Elk uur precies waar het hoort.",
            steps: [
                {
                    n: "01",
                    title: "Verkennen",
                    body: "Wij gaan bij uw team aan tafel en nemen uw processen en cijfers door — zonder aannames, zonder jargon.",
                },
                {
                    n: "02",
                    title: "Adviseren",
                    body: "Een helder advies: wat te verbeteren, in welke volgorde, en precies hoeveel tijd en geld het oplevert.",
                },
                {
                    n: "03",
                    title: "Doorvoeren",
                    body: "Wij begeleiden de verandering in gerichte stappen — waar het helpt met eigen software — terwijl uw operatie doordraait.",
                },
                {
                    n: "04",
                    title: "Borgen",
                    body: "Daarna meten, bijsturen en uitbreiden — verbeteringen die blijven hangen en meegroeien met uw bedrijf.",
                },
            ],
        },
        contact: {
            tag: "De Uitnodiging",
            headingA: "Laten we praten over",
            headingB: "uw bedrijf",
            sub: "Vertel ons waar de druk zit. Wij laten zien hoe het eruitziet als die verdwenen is.",
            note: "Liever direct contact? Mail ons — of gebruik het formulier, dan reageren we binnen één werkdag.",
            nameLabel: "Naam",
            namePlaceholder: "Uw naam",
            emailLabel: "E-mail",
            emailPlaceholder: "u@bedrijf.nl",
            companyLabel: "Bedrijf (optioneel)",
            companyPlaceholder: "Uw bedrijf",
            messageLabel: "Bericht",
            messagePlaceholder: "Vertel ons over uw bedrijf…",
            submit: "Verstuur bericht",
            sending: "Versturen…",
            success: "Bericht ontvangen — we reageren binnen één werkdag.",
            error: "Er ging iets mis. Probeer het opnieuw.",
        },
        footer: {
            tagline: "Advies over bedrijfsvoering, procesoptimalisatie en bedrijfsontwikkeling voor ondernemingen — versterkt met maatwerksoftware die bedrijfsprocessen automatiseert en optimaliseert.",
            contactLabel: "Contact",
            contactVia: "Via het contactformulier",
            location: "Nederland",
            exploreLabel: "Ontdek",
            copyright: "© 2026 Clarke Business Solutions",
            kvk: "KvK 42207779",
            motto: "Bedrijfsvoering, geperfectioneerd",
        },
    },
};
